import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=4aeb4858&scoped=true"
import script from "./navItem.vue?vue&type=script&lang=js"
export * from "./navItem.vue?vue&type=script&lang=js"
import style0 from "./navItem.vue?vue&type=style&index=0&id=4aeb4858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb4858",
  null
  
)

export default component.exports